<template>
  <div class="page beacon-single">
    <h1 class="page-title" :data-title="'Balise ' + beacon.beacon_id">Balise {{ beacon.beacon_id }}</h1>
    <div class="beacon-details">
      <p><b>Numéro de balise:</b> {{ beacon.beacon_id }}</p>
      <p><b>Numéro de micro:</b> {{ beacon.mic_id }}</p>
      <p><b>Date de placement:</b> {{ beacon.start_date }}</p>
      <p v-if="beacon.end_date"><b>Date de récupération:</b> {{ beacon.end_date }}</p>
      <p v-if="beacon.fixed_position"><b>Point fixe:</b> {{ beacon.fixed_position }}</p>
      <p><b>Longitude:</b> {{ beacon.coordinates.x }}</p>
      <p><b>Latitude:</b> {{ beacon.coordinates.y }}</p>
      <p><b>Type de terrain:</b> {{ beacon.accommodation }}</p>
      <p><b>Humidité:</b> {{ beacon.weather.dryness }}</p>
      <p><b>Vent:</b> {{ beacon.weather.wind }}</p>
      <p><b>Température:</b> {{ temperatures[beacon.weather.temperature.day] }} °C</p>
      <p v-if="beacon.comment"><b>Commentaire:</b> {{ beacon.comment }}</p>
    </div>
    <router-link class="btn" to="#">Modifier</router-link>
    <router-link class="btn" to="/">Retour</router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      beacon: {},
      temperatures: [
        '-10-0',
        '0-10',
        '10-20',
        '20-30',
        '40+'
      ]
    }
  },
  computed: mapState(['beacons']),
  created () {
    this.$store.dispatch('getBeacons')
    const beaconId = this.$route.params.index
    const result = this.beacons.filter(beacon => beacon.beacon_id === beaconId)
    this.beacon = result[0]
  }
}
</script>
